const overview = {
  content: [
    {
      title: 'Over Advance Care Planning',
      text:
        'Of u nog gezond bent of niet: het is belangrijk om na te denken over uw wensen voor zorg en behandeling voor in de toekomst.',
      link: '/'
    },
    {
      title: 'Voor wie en wanneer?',
      text:
        'Nadenken over wensen voor zorg en behandeling kan voor iedereen op een bepaald punt in het leven belangrijk zijn.',
      link: '/'
    },
    {
      title: 'Handige websites',
      text:
        'U kunt goede informatie over depressie en de hulpverlening vinden bij de landelijke organisaties van patiënten en hulpverleners.',
      link: '/'
    },
    {
      title: 'Informatie voor naasten',
      text:
        'Als naaste van iemand met een chronische ziekte of kwetsbare gezondheid heeft u mogelijk vragen over het spreken over zorgwensen of over de rol van een zorgvertegenwoordiger.',
      link: '/'
    }
  ],
  infoLinks: [
    {
      title: 'Over deze keuzehulp',
      link: '/'
    },
    {
      title: 'Disclaimer',
      link: '/'
    }
  ],
  copyright: {
    description:
      'Thuisarts.nl is een initiatief van het Nederlands Huisartsen Genootschap. Samenwerkingspartners: Federatie Medisch Specialisten, Patiëntenfederatie Nederland en Akwa GGZ.',
    links: [
      {
        title: 'Over thuisarts.nl',
        link: 'https://www.thuisarts.nl/over-thuisartsnl'
      },
      {
        title: 'Nieuws',
        link: 'https://www.thuisarts.nl/nieuws'
      },
      {
        title: 'Alle onderwerpen',
        link: 'https://www.thuisarts.nl/overzicht/onderwerpen'
      },
      {
        title: 'Films',
        link: 'https://www.thuisarts.nl/overzicht/films'
      },
      {
        title: 'Disclaimer',
        link: 'https://www.thuisarts.nl/disclaimer'
      },
      {
        title: 'Privacyverklaring',
        link: 'https://www.thuisarts.nl/privacy-en-cookiebeleid'
      }
    ]
  }
}

export default overview
